import React from 'react';
import classNames from 'classnames';

import { BrandliveEvent, HomepageFooter, LanguagesAbbr } from '../../../../types/working-model';
import NowStreamingLogo from '../../../../images/now-streaming-on-brandlive.svg?react';
import NavItem from '../../../general-ui/nav-item/nav-item';
import { getFooterStylingOverrides } from '../../utils';
import '../../../../scss/live-event/base/modules/marketing-page-footer.scss';
import '../../../../scss/live-event/base/marketing-page/footer.scss';
import { useTranslate } from '../../../../i18n/useTranslationModules';
import { useTypedSelector } from 'store/reducers/use-typed-selector';
import { EPaletteModes } from 'types/theme-packs';
import { resizedImage } from 'utils/utils';
import Image from '@general-ui/image/image';

interface FooterProps {
	footer: HomepageFooter;
	template: string;
	previewLanguage?: LanguagesAbbr;
	isLandingPage?: boolean;
}

const Footer: React.FC<FooterProps> = ({ footer, template, previewLanguage }) => {

	const eventBundle = useTypedSelector(state => state.LiveEventReducer.eventBundle);
	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);
	const event: BrandliveEvent | null = eventBundle || workingEvent;

	const themeMode = event?.settings?.design?.color_theme;
	const themeLogo = event?.settings?.design?.colors?.images?.[themeMode || EPaletteModes.Dark]?.wordmark;

	const { logo } = footer;

	const displayImage = logo || themeLogo;

	const {
		backgroundColor,
		backgroundImg,
		mainTextOverrides,
		blLogoColor
	} = getFooterStylingOverrides(footer.styling_overrides);
	const { t } = useTranslate("landing");

	const renderLinks = () => {
		const overrideColor = mainTextOverrides?.split('-')[0];
		const navItems = footer.navItems?.map((navItem, i) => {
			const override = t(`footer.${navItem.button_name.en}`, '');
			return (
				<NavItem
					key={navItem.button_name.base + i}
					navItem={navItem}
					handleScroll={() => ({})}
					className={classNames(
						"footer-nav-item",
						mainTextOverrides,
						{ [`${overrideColor}-hover`]: mainTextOverrides }
					)}
					previewLanguage={previewLanguage}
					labelOverride={override ? override : undefined}
				/>
			);
		});

		return navItems;
	};

	return (
		<footer className={
			classNames(
				"marketing-page-footer",
				template,
				backgroundColor
			)}
		>
			<div className={classNames("footer-container")} style={backgroundImg}>
				<div className={classNames("footer-left", { 'hide-mobile': !displayImage })}>
					<Image fallbackAlt="Undescribed picture" className="footer-logo" src={displayImage && resizedImage(displayImage, { height: 60 })} aria-hidden="true" />
				</div>
				<nav className="footer-nav">
					{renderLinks()}
				</nav>
				<div className="footer-right">
					<div className="footer-author">
						<NowStreamingLogo className={classNames("bl-logo", blLogoColor)} />
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
